 import Toastify from 'toastify-js'
 const mainContent = document.getElementById('site');
 const preLoaderEl = document.querySelector('.preloader');
 const headerBar = mainContent.querySelector('#masthead');
 var headerBarAnimate = gsap.timeline({
     paused: false, // default is false
     smoothChildTiming: true,
 });
 headerBarAnimate
     .fromTo(
         headerBar, {
             opacity: 0,
         }, {
             opacity: 1,
             duration: 0.5,
         },
         "<.2")
     .fromTo(headerBar, {
         scale: 0.95
     }, {
         scale: 1,
         duration: 1
     }, "<.1");
 const sideMenu = document.querySelectorAll('.orely-post-content h2');
 const tableContentLinks = document.querySelector('aside .table-of-content');
 const mobileContent = document.querySelector('.contentMobile');
 const navbarUp = document.querySelector('header')
 if (navbarUp.classList.contains('activeNav')) {
     tableContentLinks.classList.add('active')
 }
 const postTitle = document.querySelector('h1.entry-title .the-title');
 postTitle.id = 'titlepara1';
 const linkElementTitle = document.createElement('a');
 linkElementTitle.textContent = postTitle.textContent;
 linkElementTitle.href = '#' + postTitle.id;
 linkElementTitle.classList.add('content-title');
 tableContentLinks.appendChild(linkElementTitle);
 const mobileLinkElementTitle = document.createElement('a');
 mobileLinkElementTitle.textContent = postTitle.textContent;
 mobileLinkElementTitle.href = '#' + postTitle.id;
 mobileContent.appendChild(mobileLinkElementTitle);
 if (sideMenu.length > 0) {
     sideMenu.forEach((h2Element, index) => {
         const h2Content = h2Element.textContent;
         h2Element.id = 'titlepara' + (index + 2);
         const linkElement = document.createElement('a');
         linkElement.textContent = h2Content;
         linkElement.href = '#' + h2Element.id;
         linkElement.classList.add('content-title');
         linkElement.addEventListener('click', function (e) {
             e.preventDefault();
             var targetElement = document.getElementById(h2Element.id);
             var offset = 100;
             var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
             window.scrollTo({
                 top: targetPosition,
                 behavior: 'smooth'
             });
         });
         tableContentLinks.appendChild(linkElement);
         const mobileLinkElement = document.createElement('a');
         mobileLinkElement.textContent = h2Content;
         mobileLinkElement.href = '#' + h2Element.id;
         mobileContent.appendChild(mobileLinkElement);
     });
 } else {}

 const links = tableContentLinks.querySelectorAll('aside .table-of-content a');
 links.forEach(link => {
     link.addEventListener('click', function (event) {
         setActive(link);
     })
 })
 const mobileLinks = mobileContent.querySelectorAll('.content-mobile a');
 mobileLinks.forEach(link => {
     link.addEventListener('click', function (event) {
         setActive(link);
     })
 });
 function setActive(clickedLink) {
     links.forEach(link => {
         link.classList.remove('active');
     });
     clickedLink.classList.add('active');
 };
 // Mengatur link pertama sebagai aktif saat pertama kali dimuat
 setActive(links[0]);
 let dropdownMobile = document.querySelector('.table-of-content .dropdownMobile')
 let activationMobile = document.querySelector('#mobileContent')
 let tableContentMobile = document.querySelector('.contentMobile')
 let titleContentMobile = document.querySelectorAll('.contentMobile a')
 let barDropdownTitle = document.querySelector('.barDropdownTitle')
 dropdownMobile.addEventListener('click', function () {
     activationMobile.classList.toggle("active")
 });
 tableContentMobile.addEventListener('click', function (event) {
     event.stopPropagation(); // Menghentikan penyebaran event untuk mencegah dropdown tertutup
 });
 function changeContent(event) {
     event.preventDefault();
     const clickedLink = event.target;
     barDropdownTitle.textContent = clickedLink.textContent;
     // Mengarahkan ke href yang dituju oleh link yang diklik
     const targetHref = clickedLink.getAttribute('href');
     if (targetHref) {
         window.location.href = targetHref;
     };
     // Menutup dropdown setelah link diklik (opsional, sesuaikan dengan kebutuhan)
     activationMobile.classList.remove("active");
 };
 titleContentMobile.forEach(link => {
     link.addEventListener('click', changeContent);
 });
 // Copy link 
 function copyPageLink() {
     var currentPageLink = window.location.href;
     var tempInput = document.createElement("input");
     tempInput.value = currentPageLink;
     document.body.appendChild(tempInput);
     tempInput.select();
     document.execCommand("copy");
     document.body.removeChild(tempInput);
     Toastify({
         text: "Link copied to clipboard.",
         duration: 3000, // Durasi dalam milidetik (misalnya 3000 ms = 3 detik)
         gravity: "bottom", // Letak posisi toast (top, bottom, left, right)
         position: "center", // Posisi toast (top, center, bottom, left, right)
         backgroundColor: "#0F39A6", // Warna latar belakang
         className: "toastify-copylink", // Kelas CSS kustom untuk gaya tambahan
     }).showToast();
 }
 let copylink = document.querySelector('.ico__copy_link')
 copylink.addEventListener('click', copyPageLink)
 // // share to facebook
 function shareOnFacebook() {
     var currentPageLink = window.location.href;
     var articleUrl = currentPageLink;
     // Membuka dialog share Facebook dengan URL artikel
     window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(articleUrl), "_blank");
 }
 // Event listener untuk tombol "Share on Facebook"
 var facebookShareButton = document.querySelector(".ico__social_fb");
 facebookShareButton.addEventListener("click", shareOnFacebook);
 function shareToTwitter() {
     var currentPageLink = window.location.href;
     var pageTitle = document.title;
     // Buat tautan berbagi Twitter dengan URL halaman saat ini dan judul halaman sebagai teks pra-pengisian
     var twitterShareLink = 'https://twitter.com/intent/tweet' +
         '?text=' + encodeURIComponent(pageTitle) +
         '&url=' + encodeURIComponent(currentPageLink);
     // Buka tautan berbagi Twitter di jendela baru
     window.open(twitterShareLink, '_blank');
 }
 var twitterShareButton = document.querySelector(".ico__social_tw");
 twitterShareButton.addEventListener("click", shareToTwitter);
 function shareToLinkedIn() {
     var currentPageLink = window.location.href;
     var pageTitle = document.title;
     // Buat tautan berbagi LinkedIn dengan URL halaman saat ini dan judul halaman sebagai teks pra-pengisian
     var linkedinShareLink = 'https://www.linkedin.com/shareArticle' +
         '?mini=true' +
         '&url=' + encodeURIComponent(currentPageLink) +
         '&title=' + encodeURIComponent(pageTitle);
     // Buka tautan berbagi LinkedIn di jendela baru
     window.open(linkedinShareLink, '_blank');
 }
 var linkedInShareButton = document.querySelector(".ico__social_in");
 linkedInShareButton.addEventListener("click", shareToLinkedIn);



 import {
     gsap
 } from "gsap/dist/gsap";
 import {
     ScrollTrigger
 } from "gsap/dist/ScrollTrigger";
 import {
     ScrollToPlugin
 } from "gsap/dist/ScrollToPlugin";

 gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


    //  .fromTo('.wp-block-group__inner-container figure', {
    //      width: '200px',
    //      opacity: '0'
    //  }, {
    //      width: '100%',
    //      opacity: 1
    //  }, '<.1')
    //  .fromTo('.wp-block-group__inner-container figure img', {
    //      scale: 1.2
    //  }, {
    //      scale: 1
    //  }, '<.1')


 document.addEventListener("DOMContentLoaded", function () {
     document.referrer;
     if (preLoaderEl) {
         setTimeout(function () {
             preLoaderEl.classList.add('hide');
             mainContent.classList.remove('overflow-hidden');
             mainContent.classList.remove('opacity-0');
             mainContent.classList.add('opacity-100');
             window.scroll({
                 top: 0,
                 left: 0,
                 behavior: 'smooth'
             });
         }, 1300)
     }

     setTimeout(function () {
         headerBarAnimate.play();

         let timelineResourcesblog = gsap.timeline({
            paused: true, // default is false
            defaults: { // children inherit these defaults
                duration: 1.5,
                ease: "power2.out"
            },
            smoothChildTiming: true,
        });
        timelineResourcesblog
            .fromTo('.table-of-content a.active', {
                width: '0%'
            }, {
                width: '100%'
            })
            .fromTo('.entry-title', {
                scale: 0.7,
                y: '10px',
                opacity: 0,
            }, {
                scale: 1,
                opacity: 1,
                y: '0px'
            }, '<.1')
            .fromTo('.entry-meta', {
                scale: 0.7,
                opacity: 0,
            }, {
                scale: 1,
                opacity: 1
            }, '<.2')
            .fromTo('.right .icon-only', {
                opacity: 0,
                y: '20px'
            }, {
                opacity: 1,
                y: '0px',
                stagger: .2
       
            }, '<.1')
            .play();

            

            const orelyPattern = document.querySelectorAll('.orely-pattern');
            orelyPattern.forEach((element, index) => {
                element.childNodes.forEach((elementChild, subIndex) => {
                    const contentAnimate = gsap.timeline({
                        paused: false, // Atur menjadi true agar animasi tidak dijalankan secara otomatis
                        scrollTrigger: {
                            trigger: elementChild,
                            start: "top 95%",
                            end: "bottom center"
                        },
                        smoothChildTiming: true
                    });
            
                    elementChild.childNodes.forEach(el => {
                        if (el instanceof HTMLElement) {
                            if (el.tagName.toLowerCase() === 'figure') {
                                // Jika elemen adalah <figure>, terapkan overflow: hidden
                                el.style.overflow = 'hidden';
                                
                                // Jika elemen memiliki elemen <img>, terapkan animasi scale pada <img>
                                const img = el.querySelector('img');
                                if (img) {
                                    contentAnimate.fromTo(img, {
                                        scale: 1.2,
                                        opacity: 0
                                    }, {
                                        scale: 1,
                                        opacity: 1,
                                        duration: 0.8
                                    }, "<.2");
                                }
                            } else {
                                // Jika elemen bukan <figure>, terapkan animasi fade
                                contentAnimate.fromTo(el, {
                                    opacity: 0,
                                    y: '40px',
                                }, {
                                    y: '0px',
                                    opacity: 1,
                                    duration: 0.8,
                                }, "<.2");
                            }
                        }
                    });
                });
            
 
            //  const observer = new IntersectionObserver((entries, observer) => {
            //     entries.forEach(entry => {
            //         if (entry.isIntersecting) {
            //             cardAnimate.play(); // Jalankan animasi jika card masuk ke viewport
            //             observer.unobserve(entry.target); // Berhenti mengamati card setelah animasi dijalankan
            //         }
            //     });
            // });

            // observer.observe(element);
         });
     }, 1300);
 })